import { useCallback } from "react";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg", "heic"];

export const isImageUrl = (url) => {
  if (!url) return false;
  try {
    const pathname = decodeURIComponent(new URL(url).pathname).toLowerCase();
    const ext = pathname.split(".").pop();
    return IMAGE_EXTENSIONS.includes(ext);
  } catch {
    return /\.(jpe?g|png|gif|webp|bmp|svg|heic)(\?|$)/i.test(url);
  }
};

const useDocumentPreview = () => {
  const openDocumentPreview = useCallback((url) => {
    if (!url) return;
    const target = isImageUrl(url)
      ? url
      : `https://docs.google.com/viewer?url=${encodeURIComponent(url)}`;
    window.open(target, "_blank", "noopener,noreferrer");
  }, []);

  return { openDocumentPreview };
};

export default useDocumentPreview;